<template>
	<div id="app" class="wrapper">
		<app-header></app-header>
		<router-view/>
		<app-footer></app-footer>
	</div>
</template>
<script>
import appHeader from '@/components/appHeader'
import appFooter from '@/components/appFooter'
export default {
  name: 'app',
  components: {
	  'app-header': appHeader,
	  'app-footer': appFooter
  }
}
</script>
<style>
 @import url('https://fonts.googleapis.com/css?family=Anonymous+Pro|Noto+Sans');
:root {
  --canvas: #eee;
  --canvas-light: #fcfcfc;

  --shadow: rgba(0,0,0,0.2);
  --shadow-light: #ddd;
  --shadow-dark: rgba(0,0,0,0.4);

  --text-dense: #222;
  --text-light: #444;
  --text-faded: #777;

  --accent: #25a;
  --accent-light: #47d;
  --accent-dark: #149;

  --accent-second: #a32;
  --accent-second-light: #d74;
  --accent-second-dark: #920;

  --gap: 10px;
  --gap-huge: 20px;
}
body {
   font: 16px/1.5 "Noto Sans", sans-serif;
	 unicode-bidi: bidi-override;
   margin: 0;
   color: var(--text-light);
   background-color: var(--canvas);
	 overflow-y: scroll;
}
.center {
  text-align:center;
}
pre {
   font: 16px/1.5 "Anonymous Pro", monospace;
}
h1, h2, h3, h4 {
  color: var(--text-dense);
  margin: 0 0 1em 0;
  text-shadow: 2px 2px 0 var(--canvas-light);
}
h1 {
  font-size: 2em;
  color: var(--accent);
}
h2 {
  font-size: 1.5em;
	text-align: center;
}
h3 {
    font-size: 1.2em;
}
h4 {
	font-size: 1em;
}
p {
  margin: 0;
  margin-bottom: var(--gap);
}
a {
    text-decoration: none;
    color: var(--accent);
	border-bottom: 1px dashed transparent;
	outline: none;
}
a:visited {
    color: var(--accent-dark);
}
a:hover, a:focus {
    color: var(--accent-light);
    border-bottom-color: var(--accent-light);
}
input, textarea, button, .paper {
  font: 16px/1.5 "Noto Sans", sans-serif;
  color: var(--text-light);
  padding: var(--gap);
  background-color: var(--canvas-light);
  border: 2px solid transparent;
  border-left-color: white;
  border-top-color: white;
  border-radius: 5px;
}
input::placeholder, textarea::placeholder, option[disabled] {
    color: var(--text-light);
    opacity: 0.8;
}
*:invalid {
    box-shadow: none;
    border-color: var(--accent-second-light);
}
button::-moz-focus-inner {
    border: 0;
}
input:focus, textarea:focus {
    box-shadow: 5px 5px 0 var(--shadow);
    outline: none;
    border-color: var(--accent-light);
}
input[type=checkbox] {
  display: none;
}
.checkbox {
  position: relative;
  margin-left: 50px;
}
.checkbox label {
  font-size: 1.2em;
}
.checkbox label::before {
  content: '';
  position: absolute;
  left: -50px;
  width: 30px;
  height: 26px;
  background-color: var(--canvas-light);
  border-radius: 5px;
  border: 2px solid transparent;
  border-left-color: white;
  border-top-color: white;
}
.paper .checkbox label::before {
  background: var(--canvas);
  border-top-color: var(--shadow-light);
  border-left-color: var(--shadow-light);
  border-right-color: white;
  border-bottom-color: white;
}
.checkbox label::after {
  position: absolute;
  left: -40px;
  top: -22px;
  font-size: 3em;
  line-height: 1;
	transform: rotate(-135deg);
	text-shadow: -1px -1px 0 var(--canvas-light);
}
.checkbox label:hover::after {
  content: 'Γ';
  color: var(--shadow);
}
.checkbox input:checked + label::after {
  content: 'Γ';
  color: var(--accent-light);
}
.checkbox label:focus {
  outline: none;
}
.checkbox label:hover::before, .checkbox label:focus::before {
  box-shadow: 5px 5px 0 var(--shadow);
}
button {
  /* width: 100%; */
	cursor: pointer;
  padding: var(--gap);
  background-color: var(--accent);
  color: var(--canvas);
  border-radius: 20px;
  border: 2px solid transparent;
  border-top-color: var(--accent-light);
  border-bottom-color: var(--accent-dark);
}
button:hover, button:focus {
	outline: none;
  border-left-color: var(--accent-light);
  border-right-color: var(--accent-dark);
  box-shadow: 5px 5px 0 var(--shadow);
	text-shadow: 0px -2px 2px var(--accent-dark),
		0px 2px 2px var(--accent-light);
}
button:active {
  top: 2px;
  box-shadow: none;
	text-shadow: 0 2px 2px var(--accent-dark),
		0 -2px 2px var(--accent-light);
  border-top-color: var(--accent-dark);
  border-left-color: var(--accent-dark);
  border-right-color: var(--accent-light);
  border-bottom-color: var(--accent-light);
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
label {
  display: inline-block;
  text-shadow: 1px 1px 0 var(--canvas-light);
}
label::selection {
  background: transparent;
}
label::-moz-selection {
  background: transparent;
}
.wrapper {
    max-width: 720px;
    padding: var(--gap-huge);
    margin: 0 auto;
}
.fade-enter {
	opacity: 0;
}
.fade-enter-active {
	transition: all .4s ease;
}
.fade-leave-active {
	transition: all 0s ease;
}
.paper {
  position: relative;
  padding: var(--gap-huge);
  word-wrap: anywhere;
}
.aside {
  width: 60%;
  margin-left: var(--gap);
  float: right;
}
.aside img {
  width: 100%;
  display: block;
}
.paper > button {
  position: absolute;
  top: 0px;
  right: 0px;
  transform: translate(30%, -60%);
  padding: 0;
  border-radius: 1em;
  box-sizing: content-box;
  min-width: 1em;
  line-height: 1;
  font-size: 3em;
}
.floating-btn {
  padding: 5px 10px;
  margin: 5px;
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 50px 10px 10px 50px;
}
.floating-btn:hover,
.floating-btn:focus {
  box-shadow: 2px 2px 0 var(--shadow);
}
.paper input {
  background: var(--canvas);
  border-top-color: var(--shadow-light);
  border-bottom-color: white;
}
#programs .paper input {
  background-color: var(--canvas-light);
}
.paper input.invalid, .paper input.invalid:focus {
  border-color: var(--accent-second-light);
}
.paper input:focus,
.paper input:hover {
  border-color: var(--accent-light);
}
.paginate-links {
  display: flex;
  justify-content: center;
  list-style: none;
}
.paginate-links a {
  cursor: pointer;
}
.number a, .ellipses a {
  display: block;
  margin: 0 var(--gap);
  background: var(--shadow-light);
  border: 0;
  color: var(--text-light);
  width: 1.5em;
  text-align: center;
  padding: var(--gap);
  border-radius: 50%;
}
.number.active a {
  background: var(--accent);
  color: white;
}
</style>
